import React, { useEffect, useState } from "react";
import { useLoadScript, GoogleMap, Marker, Circle, InfoWindow } from '@react-google-maps/api';

const apiKey = "AIzaSyC_G16AeOUmhNAP9FuTvreRhFTs31bL4mQ";

const MapStudentLocation = (props) => {
    const { studentsWithCoordinates, schoolCoordinates, lstRanges, rangeId } = props;

    // State to track the currently clicked marker or circle
    const [clickedStudent, setClickedStudent] = useState(null);
    const [clickedRange, setClickedRange] = useState(null);
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: apiKey, 
        // googleMapsApiKey: process.env.REACT_APP_API_KEY,
        libraries: ['drawing', 'geometry']
    });

    useEffect(() => {
        // console.log("Map component called, studentsWithCoordinates updated" );
        // console.log("studentsWithCoordinates", studentsWithCoordinates);
    }, [studentsWithCoordinates]);

    useEffect(() => {
        // console.log("Map component called, schoolCoordinates updated" );
    }, [ schoolCoordinates]);

    useEffect(() => {
        // console.log("Map component called, lstRanges updated" );
    }, [ lstRanges, rangeId]);

    useEffect(() => {
        // console.log("Map component called, rangeId updated" );
    }, [ rangeId]);



    return (

        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
            {
                isLoaded && !loadError ? (
                    <GoogleMap
                        center={schoolCoordinates}
                        zoom={13}
                        mapContainerStyle={{ width: "100%", height: "80vh" }}
                        options={{
                            zoomControl: true, // Enable zoom controls
                            zoomControlOptions: {
                                position: window.google.maps.ControlPosition.RIGHT_CENTER, // Position of the zoom controls
                            },
                            // fullscreenControl: true, 
                            mapTypeControl: true,
                        }}
                    >
                        {/* School Marker */}
                        <Marker position={schoolCoordinates} label="School" />

                        {/* Additional Pointers */}
                        {studentsWithCoordinates.map((student) => (
                            <React.Fragment key={student.studentId}>
                                {student.coordinate && (
                                    <Marker
                                        position={student.coordinate}
                                        icon={{
                                            url: "https://sms.cooledsys.com//school_kid.png", // URL of the custom icon
                                            scaledSize: new window.google.maps.Size(30, 30), // Resize the icon
                                        }}
                                        onClick={() => setClickedStudent(student)} // Set clicked student
                                    />
                                )}
                                {clickedStudent?.studentId === student.studentId && (
                                    <InfoWindow
                                        position={student.coordinate}
                                        onCloseClick={() => setClickedStudent(null)} // Close InfoWindow on click
                                    >
                                        <div style={{ fontSize: "12px", maxWidth: "100px", padding: "1px" }}>
                                            <strong>{student.student}</strong>
                                            <br />
                                            ID: {student.studentId}
                                        </div>
                                    </InfoWindow>
                                )}
                            </React.Fragment>
                        ))}

                        {/* Circles and InfoWindows for ranges */}
                        {lstRanges.map((range, index) => {
                            // Find the currently selected range (if any)
                            const selectedRange = lstRanges.find(r => r.rangeId === rangeId);

                            // If a range is selected and the current range is smaller (i.e. inner), then DO NOT highlight it.
                            // Otherwise, if the current range is the selected one then highlight it.
                            const isSelected = range.rangeId === rangeId;
                            const shouldHighlight =
                                isSelected ||
                                (!selectedRange || range.km >= selectedRange.km); // for non-concentric cases adjust as needed

                            return (
                                <React.Fragment key={range.rangeId}>
                                    <Circle
                                        center={schoolCoordinates}
                                        radius={range.km * 1000}
                                        options={{
                                            fillColor: isSelected ? "#00FF00" : "", 
                                            fillOpacity: isSelected ? 0.2 : 0, 
                                            strokeColor: isSelected ? "#008000" : "#800000",
                                            strokeOpacity: 0.8,
                                            strokeWeight: 1,
                                        }}
                                    />
                                    {clickedRange?.rangeId === range.rangeId && (
                                        <InfoWindow
                                            position={{
                                                lat: schoolCoordinates.lat + (index * 0.01),
                                                lng: schoolCoordinates.lng,
                                            }}
                                            onCloseClick={() => setClickedRange(null)}
                                        >
                                            <div>{range.km} km area</div>
                                        </InfoWindow>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </GoogleMap>
                ) : loadError ? (
                    <h2>Error Loading Map</h2>
                ) : (
                    <h2>Loading...</h2>
                )
            }
        </div>
    );
};

export default MapStudentLocation;
